import React from 'react';
import { Avatar, Box } from '@mui/material';
import { Outlet } from 'react-router-dom';

import imageLogo from '../../assets/logoBasis.jpg';
import visitka from '../../assets/visitka.jpg';

export const LayoutAuth = () => {
  return (
    <Box width="100%" height="100vh" boxSizing="100vh" display="flex">
      <Box
        minWidth={600}
        maxWidth={800}
        flex={1}
        bgcolor="#18318e"
        pl={1}
        pt={1}
        boxSizing="border-box"
        position="relative"
      >
        <Avatar
          variant={'rounded'}
          alt="The image"
          src={imageLogo}
          style={{
            width: 527 * 0.7,
            height: 743 * 0.7,
          }}
        />
        <Avatar
          variant={'rounded'}
          alt="The image"
          src={visitka}
          style={{
            position: 'absolute',
            bottom: 0,
            right: 0,
            width: 604 * 0.4,
            height: 698 * 0.4,
          }}
        />
      </Box>
      <Box flex={1}>
        <Outlet />
      </Box>
    </Box>
  );
};
